module.exports = __webpack_public_path__ + "img/logo-green.e4c7a323.png";